import { BreadCrumbItem } from "../../atoms/breadCrumbItem/BreadCrumbItem";
import { useRef } from "react";
import { RoutesList } from "../../../routes/Routes";

const Divider = () => {
  return (
    <div className="mx-2 mt-3 w-full border-t border-secondary-gray md:mx-5 lg:mx-6 xl:mx-6"></div>
  );
};

type BreadCrumbProps = {
  pathname: string;
};

export const BreadCrumbs = (prop: BreadCrumbProps) => {
  const styleRef = useRef("bg-primary-gray font-semibold text-white");

  return (
    <div
      aria-label="Breadcrumbs"
      className="mx-3 mb-1 mt-12 flex justify-between pb-10"
    >
      <BreadCrumbItem
        label="Upload photo"
        progress={
          prop.pathname !== RoutesList.UPLOAD_PHOTO
            ? "✔"
            : "1"
        }
        className={`${
          prop.pathname === RoutesList.UPLOAD_PHOTO
            ? styleRef.current
            : ""
        }`}
      />
      <Divider />
      <BreadCrumbItem
        label="Waste details"
        progress={
          prop.pathname !== RoutesList.WASTE_DETAILS && prop.pathname !== RoutesList.UPLOAD_PHOTO
            ? "✔"
            : "2"
        }
        className={`${
          prop.pathname === RoutesList.WASTE_DETAILS
            ? styleRef.current
            : ""
        }`}
      />
      <Divider />
      <BreadCrumbItem

        label="Your details"
        progress="3"
        className={`${
          prop.pathname === RoutesList.YOUR_DETAILS
            ? styleRef.current
            : ""
        }`}
      />
    </div>
  );
};
